module.exports = __webpack_public_path__ + "static/media/console.8c61bb06.svg";